import getImage from "./GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import ReportsAPI from './../../../../Reports/api/reports_api';

const pdfPrintInfoLetterProcedure = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };
  console.log("ComingToPDFPayment", data);

  const city = parseInt(data.profile.direccion.id_ciudad);
  const dept = parseInt(data.profile.direccion.id_dpto);
  const getCity = await ReportsAPI.loadCity(city);
  const getDepts = await ReportsAPI.loadDepartment();
  const deptoProfile = getDepts.find((depto) => depto.id === dept);
  const today = new Date();


  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.direccion.direccion +
              " " +
              data.profile.nombre +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2,
            style: "head",
          },
        ],
      ],
    },
  };

  const documentDefinition = {
    pageSize: "LEGAL",
    pageOrientation: "portrait",
    /* header: header,
    pageMargins: [30, 70, 30, 40],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              {
                text:
                  "Fecha Impresión: " + moment(today).format('DD-MM-YYYY'),
                style: "head",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 30, 5],
      };
    }, */
    content: [
      { text: data.profile.nombre, style: "headPayment", margin: [10, 10, 100, 3] },
      {
        table: {
          widths: ["auto", "*", "auto", "*"],
          body: [
            [{ text: 'Nombre:', style: "textStyle", border: [false, true, false, false], bold: true }, { text: data.namePatient, style: "textStyle", colSpan: 3, border: [false, true, false, false] }, '', ''],
            [{ text: 'Identificación:', style: "textStyle", bold: true }, { text: data.id, style: "textStyle" }, '', ''],
            [{ text: 'Fecha:', style: "textStyle", bold: true }, { text: data.dateProcedure + " " + data.hourProcedure, style: "textStyle" },'', ''],
            [{ text: 'Entidad:', style: "textStyle", bold: true }, { text: data.thirdName, style: "textStyle", colSpan: 3 }, '', ''],
            [{ text: data.serviceName, style: "textStyle", border: [false, false, false, true], bold: true, colSpan: 4 }, '', '', ''],
          ],
        },
        layout: {
          defaultBorder: false,
        },
        margin: [10, 10, 120, 10],
      },
    ],
    styles: {
      headPayment: {
        fontSize: 12,
        bold: true,
      },
      headResumenPayment: {
        fontSize: 10,
        bold: true,
      },
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      tableheaderFloarRight: {
        fontSize: 11,
        bold: true,
        alignment: 'right'
      },
      textStyle: {
        fontSize: 10,
      },
      textStyleValueIncome: {
        fontSize: 10,
        alignment: "right"
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        margin: [0, 5, 0, 0],
        fontSize: 10,
        alignment: "left",
      },
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });

  //pdfMake.createPdf(documentDefinition).open();
};
export default pdfPrintInfoLetterProcedure;
